<template>
  <div class="user-manage">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="岗位编码" prop="jobId">
                <el-input class="handle-input" v-model="queryCondition.jobId" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="岗位名称" prop="jobName">
                <el-input class="handle-input" v-model="queryCondition.jobName" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryForm()">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row>
        <el-button type="primary" @click="onAdd">新增</el-button>
        <el-button type="primary" @click="onDel">删除</el-button>
      </el-row>
      <el-table :data="tableData" @selection-change="handleSelectionChange" border highlight-current-row max-height="450" style="margin-top:20px;">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip fixed prop="jobType" label="岗位类型">
          <template slot-scope="scope">{{scope.row.jobType | ic('TM_USER_JOB','JOB_TYPE')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip fixed prop="jobId" label="岗位编码"></el-table-column>
        <el-table-column show-overflow-tooltip fixed prop="jobName" label="岗位名称"></el-table-column>
        <el-table-column :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editUserInfo(scope.row)">编辑</el-button>
            <el-button @click.native.prevent="userRoleEdit(scope.row.tmUserJobId)" type="primary" size="mini">添加角色</el-button>
            <el-button @click.native.prevent="setDataPermission(scope.row)" type="primary" size="mini" v-if="scope.row.jobType=='SUP'">数据权限</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
    <el-dialog title="岗位信息" :visible.sync="isAddDialog" width="30%" :close-on-click-modal="false" @closed="onCancel" class="userInfo_dialog">
      <el-form :model="postForm" ref="postForm" :rules="postRules" :label-position="labelPosition" label-width="100px">
        <el-form-item label="岗位类型" prop="jobType">
          <ic-select table="TM_USER_JOB" field="JOB_TYPE" v-model="postForm.jobType" style="width:100%"></ic-select>
        </el-form-item>
        <el-form-item label="岗位编码" prop="jobId">
          <el-input v-model="postForm.jobId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="岗位名称" prop="jobName">
          <el-input v-model="postForm.jobName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-row type="flex" justify="center" style="margin-top:5px">
          <el-button type="primary" @click="onSave">保存</el-button>
          <el-button @click="onCancel">关闭</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :title="$t('sys.userList.roleSelection')" :visible.sync="showUserRole" width="60%">
      <div style="text-align: center">
        <el-transfer style="text-align: left; display: inline-block" filterable v-model="selRoles" :data="notSelRoles" :titles="[$t('sys.userList.roleSource'), $t('sys.userList.roleTarget')]"></el-transfer>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="onCancel1">{{$t('common.close')}}</el-button>
        <el-button type="primary" @click="saveUserRole">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="数据权限" :visible.sync="dataPermissionDialogVisible" width="60%">
      <el-form :model="userInfo" ref="userInfoForm">
        <div class="title_box">
          <p class="line"></p>
          <p class="title">数据权限</p>
        </div>
        <div class="user_info">
          <el-row :gutter="24">
            <el-col>
              <table class="user_table">
                <tr>
                  <td class="title">模块</td>
                  <td class="title">权限值</td>
                </tr>
                <tr>
                  <td>HGS供应商、RMC采购量</td>
                  <td>
                    <el-form-item label-width="0" prop="defaultDataScope">
                      <ic-select table="TM_USER" field="DATA_SCOPE" v-model="userInfo.defaultDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>StoreFeedBack</td>
                  <td>
                    <el-form-item label-width="0" prop="feedbackDataScope">
                      <ic-select table="TM_USER" field="DATA_SCOPE_TYPE_FEEDBACK" v-model="userInfo.feedbackDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>Sensory</td>
                  <td>
                    <el-form-item label-width="0" prop="sensoryDataScope">
                      <ic-select table="TM_USER" field="DATA_SCOPE_TYPE_SENSORY" v-model="userInfo.sensoryDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>Nutrition</td>
                  <td>
                    <el-form-item label-width="0" prop="nutritionDataScope">
                      <ic-select table="TM_USER" field="NUTRITION_DATA_SCOPE" v-model="userInfo.nutritionDataScope" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="onSavePermission">{{$t('common.save')}}</el-button>
            <el-button type="primary" @click="onCancelPermission">{{$t('common.close')}}</el-button>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { userService } from "../../../api/user-manage/user";
import { fileService } from "@/api/common/file-utils";
import { Message } from "element-ui";
import QIPApi from "@/api/QIP/index";
import commonFunction from "../../../utils/dataTableUtils";
import commonConstants from "@/constants/commonConstants";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import PickupUser from "@/components/common/pickupUser";
import { roleService } from "../../../api/user-manage/role";
export default {
  name: "user-manage",
  components: { PickupUser, IcSelect },
  data() {
    return {
      userInfo: {
        defaultDataScope: "",
        feedbackDataScope: "",
        sensoryDataScope: "",
        nutritionDataScope: "",
      },
      dataPermissionDialogVisible: false,
      tmUserJobId: "",
      tableData: [],
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        jobId: '',
        jobName: "",
      },
      isAddDialog: false,
      postForm: {
        jobId: '',
        jobName: "",
        jobType: ""
      },
      postRules: {
        jobName: [
          {
            required: true,
            message: '请输入岗位名称',
            trigger: "blur"
          }
        ],
        jobId: [
          {
            required: true,
            message: '请输入岗位编码',
            trigger: "blur"
          }
        ],
        jobType: [
          {
            required: true,
            message: '请选择岗位类型',
            trigger: "change"
          }
        ],
      },
      multipleSelection: [],
      showUserRole: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
    };
  },
  created() {
    this.queryData(1);
  },
  methods: {
    setDataPermission(row) {
      this.tmUserJobId = row.tmUserJobId
      userService.getPostInfo(row.tmUserJobId).then(res => {
        console.log("GY🚀 ~ file: post.vue:174 ~ userService.getPostInfo ~ res:", res);
        if (res.code == '200') {
          this.userInfo = Object.assign({}, res.data.dataScope)
          this.dataPermissionDialogVisible = true
        }
      });

    },
    onSavePermission() {
      let params = Object.assign({}, this.userInfo)
      userService.savePostUserInfo(this.tmUserJobId, params).then(res => {
        console.log("GY🚀 ~ userService.savePostUserInfo ~ res:", res);
        if (res.code == '200') {
          Message({ message: this.$t("common.saveSuccess"), type: "success" });
          this.dataPermissionDialogVisible = false;
          this.queryData(1);
        } else {
          Message({ message: this.$t("common.saveError"), type: "error" });
        }
      });
    },
    onCancelPermission() {
      this.dataPermissionDialogVisible = false;
      this.userInfo = {
        defaultDataScope: "",
        feedbackDataScope: "",
        sensoryDataScope: "",
        nutritionDataScope: "",
      }
      this.queryData(1);
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      userService.getPost(this.queryCondition).then(res => {
        console.log("GY🚀 ~ file: post.vue:222 ~ userService.getPost ~ res:", res);
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDel() {
      this.$confirm('请确认是否删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userJobIds = this.multipleSelection.map(ele => ele.tmUserJobId)
        console.log("GY🚀 ~ file: post.vue:142 ~ onDel ~ userJobIds:", userJobIds);
        userService.deletePostInfo(userJobIds).then(res => {
          console.log("GY🚀 ~ file: post.vue:144 ~ userService.getPost ~ res:", res);
          this.$message.success('删除成功')
          this.queryData(1);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onAdd() {
      this.isAddDialog = true
    },
    onSave() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          userService.savePostInfo(this.postForm).then(res => {
            console.log("GY🚀 ~ file: post.vue:137 ~ userService.savePostInfo ~ res:", res);
            if (res.code == '200') {
              this.$message.success('保存成功')
              this.queryData(1);
              this.isAddDialog = false
              this.postForm = {
                jobId: '',
                jobName: "",
                jobType: ""
              }
            }
          });
        }
      })
    },
    onCancel() {
      this.queryData(1);
      this.isAddDialog = false
      this.postForm = {
        jobId: '',
        jobName: "",
        jobType: ""
      }
      this.$refs['postForm'].resetFields()
    },
    editUserInfo(row) {
      userService.getPostInfo(row.tmUserJobId).then(res => {
        console.log("GY🚀 ~ file: post.vue:174 ~ userService.getPostInfo ~ res:", res);
        if (res.code == '200') {
          this.isAddDialog = true
          this.postForm = res.data
        }
      });
    },
    //用户角色设置
    userRoleEdit(tmUserJobId) {
      // userService.getUserRole(userId).then(res => {
      //   (this.notSelRoles = res.data.allRole),
      //     (this.selRoles = res.data.sel),
      //     (this.showUserRole = true);
      //   this.userId = userId;
      // });
      userService.getPostInfo(tmUserJobId).then(res => {
        console.log("GY🚀 ~ file: post.vue:204 ~ userService.getPostInfo ~ res:", res);
        if (res.code == '200') {
          this.selRoles = res.data.roles.map(ele => ele.tmRoleId)
          console.log("GY🚀 ~ file: post.vue:213 ~ userService.getPostInfo ~ this.selRoles:", this.selRoles);
          this.userId = tmUserJobId;
          this.getAllUserRole(this.selRoles)
          this.showUserRole = true
        }
      });
    },
    onCancel1() {
      this.selRoles = []
      this.notSelRoles = []
      this.userId = ''
      this.showUserRole = false
    },
    getAllUserRole(selRoleIds) {
      roleService.getRoleData({
        pageSize: -1
      }).then((res) => {
        console.log("GY🚀 ~ file: post.vue:217 ~ getAllUserRole ~ res:", res);
        if (res.resultData.length > 0) {
          this.notSelRoles = []
          res.resultData.forEach(ele => {
            this.notSelRoles.push({
              key: ele.tmRoleId,
              label: ele.roleNameCn
            })
          })
          console.log("GY🚀 ~ file: post.vue:238 ~ getAllUserRole ~ this.notSelRoles:", this.notSelRoles);


        }
      });
    },
    //保存用户角色
    saveUserRole() {
      userService.savePostRole(this.selRoles, this.userId).then(res => {
        console.log("GY🚀 ~ file: post.vue:200 ~ userService.savePostRole ~ res:", res);
        if (res.code == '200') {
          this.showUserRole = false
          Message({ message: this.$t("common.saveSuccess"), type: "success" });
        } else {
          Message({ message: this.$t("common.saveError"), type: "error" });
        }
      });
    },
    restQueryForm() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        jobId: '',
        jobName: "",
      }
      this.queryData(1);
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.user-manage {
  .deleteFile {
    margin-top: 40px;
    margin-left: 10px;
  }
  .avatar-uploader .el-upload {
    border: 1px solid #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    float: left;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .handle-input {
    width: 95%;
  }
  .form_border {
    border: 1px solid #eaeefb;
    padding: 10px 10px 0;
  }

  /*穿梭框样式重写*/
  .el-transfer .el-transfer-panel {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    display: inline-block;
    vertical-align: middle;
    width: 300px;
    max-height: 100%;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 40px;
  }
  .el-transfer-panel__body {
    height: 370px;
  }
  .el-transfer-panel__list.is-filterable {
    height: 360px;
  }
}
</style>
